import { useEffect, useState } from "react";
import { Search, ChevronDown } from "lucide-react";
import api from "@/api/client";

export const CATEGORIES = [
  "All",
  "Motors",
  "Controllers",
  "Forks",
  "Wheels",
  "Handlebars",
  "Motor Covers",
  "Plastics",
];

export const FITMENTS = ["All", "Surron Light Bee X", "Surron Ultra Bee", "Talaria Sting R", "E-Ride Pro SS 2.0", "Stark Varg"];

export function FilterBar({ category, setCategory, fitment, setFitment, maxPrice, setMaxPrice, search, setSearch }) {
  const [catOpen, setCatOpen] = useState(false);
  const [fitOpen, setFitOpen] = useState(false);
  const [itemCats, setItemCats] = useState(CATEGORIES);
  const [bikeCats, setBikeCats] = useState(FITMENTS);

  useEffect(() => {
    api.get("/categories").then(({ data }) => {
      const items = data.filter((c) => c.type === "item").map((c) => c.name);
      const bikes = data.filter((c) => c.type === "bike").map((c) => c.name);
      if (items.length) setItemCats(["All", ...items]);
      if (bikes.length) setBikeCats(["All", ...bikes]);
    }).catch(() => {});
  }, []);

  return (
    <div className="border border-white/10 bg-surface p-4 sm:p-6" data-testid="filter-bar">
      <div className="grid gap-4 md:grid-cols-4">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-500" />
          <input
            type="text"
            placeholder="SEARCH PARTS..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full border border-white/10 bg-obsidian py-3 pl-10 pr-4 font-mono text-sm uppercase tracking-widest text-white placeholder:text-slate-600 focus:border-volt focus:outline-none"
            data-testid="filter-search"
          />
        </div>

        <div className="relative">
          <button
            onClick={() => { setCatOpen(!catOpen); setFitOpen(false); }}
            className="flex w-full items-center justify-between border border-white/10 bg-obsidian px-4 py-3 font-mono text-sm uppercase tracking-widest text-white focus:border-volt focus:outline-none"
            data-testid="filter-category"
          >
            {category}
            <ChevronDown className="h-4 w-4" />
          </button>
          {catOpen && (
            <div className="absolute left-0 right-0 top-full z-10 mt-1 border border-white/10 bg-obsidian" data-testid="filter-category-dropdown">
              {itemCats.map((c) => (
                <button
                  key={c}
                  onClick={() => { setCategory(c); setCatOpen(false); }}
                  className={`block w-full px-4 py-3 text-left font-mono text-sm uppercase tracking-widest transition-colors hover:bg-surface ${category === c ? "text-volt" : "text-slate-300"}`}
                  data-testid={`filter-category-${c.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  {c}
                </button>
              ))}
            </div>
          )}
        </div>

        <div className="relative">
          <button
            onClick={() => { setFitOpen(!fitOpen); setCatOpen(false); }}
            className="flex w-full items-center justify-between border border-white/10 bg-obsidian px-4 py-3 font-mono text-sm uppercase tracking-widest text-white focus:border-volt focus:outline-none"
            data-testid="filter-fitment"
          >
            {fitment}
            <ChevronDown className="h-4 w-4" />
          </button>
          {fitOpen && (
            <div className="absolute left-0 right-0 top-full z-10 mt-1 border border-white/10 bg-obsidian" data-testid="filter-fitment-dropdown">
              {bikeCats.map((f) => (
                <button
                  key={f}
                  onClick={() => { setFitment(f); setFitOpen(false); }}
                  className={`block w-full px-4 py-3 text-left font-mono text-sm uppercase tracking-widest transition-colors hover:bg-surface ${fitment === f ? "text-volt" : "text-slate-300"}`}
                  data-testid={`filter-fitment-${f.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  {f}
                </button>
              ))}
            </div>
          )}
        </div>

        <div className="flex items-center gap-4 border border-white/10 bg-obsidian px-4 py-3">
          <span className="font-mono text-xs uppercase tracking-widest text-slate-500">Max ${maxPrice}</span>
          <input
            type="range"
            min="20"
            max="2000"
            value={maxPrice}
            onChange={(e) => setMaxPrice(Number(e.target.value))}
            className="flex-1 accent-[#00A3FF]"
            data-testid="filter-price"
          />
        </div>
      </div>
    </div>
  );
}
